// Module
var code = "<a href=\"#\" class=\"btn query-result-button\"> <i class=\"fa transition fa-play run-query-icon\"></i> Run query </a>";
// Exports
export default code;